import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';

/**
 * The shared elevated circular surface behind logo/avatar badges — rounded,
 * centered, with the site's ring + shadow (subtle in light, zinc border in
 * dark). Single source for that design token: the home resume, project logos,
 * and featured list all render through it.
 *
 * Pass per-use classes via `className` for the bits that vary:
 *   - image logos:   `overflow-hidden dark:border dark:border-zinc-700/50`
 *   - monograms:     `bg-zinc-100 text-zinc-500 dark:text-zinc-400`
 *   - size/position: `size-10 mt-1 flex-none`, `size-12 z-10`, etc.
 */
export function LogoBadge(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("relative flex items-center justify-center rounded-full shadow-md ring-1 shadow-zinc-800/5 ring-zinc-900/5 dark:bg-zinc-800 dark:ring-0", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}